// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "b[data-v-170080f8]{font-weight:500}.flex[data-v-170080f8]{display:flex;justify-content:space-between;align-items:center}.amount[data-v-170080f8]{color:var(--color-darker-grey);font-size:var(--font-size-small);font-weight:500}.grooviesIcon[data-v-170080f8]{margin-left:4px;width:16px;height:16px}", ""]);
// Exports
module.exports = exports;
